'use client'

import NextImage, { ImageProps, ImageLoaderProps } from 'next/image'
import React, { useState } from 'react'
import { cloudflareImageLoader } from './cloudflare-loader'

const FALLBACK_IMAGE = 'image/default/200/200/default.png'

export type SafeNumber = number | `${number}`

// Updated loader function
function loaderFunction(args: ImageLoaderProps) {
  const { src, width, quality } = args
  return cloudflareImageLoader({
    src,
    width,
    height: undefined,
    quality: quality ?? 75,
    options: { objectFit: true },
  })
}

// Refactored Image component
export const Image = (props: ImageProps) => {
  const [isFallback, setIsFallback] = useState(false)
  return (
    <NextImage
      {...props}
      style={{ objectFit: 'contain', ...props.style }}
      src={isFallback || !props.src ? FALLBACK_IMAGE : props.src}
      loader={props.loader ?? loaderFunction}
      onError={() => setIsFallback(true)}
    />
  )
}

export default Image
